export default __webpack_public_path__ + "static/media/cooker3.b0582ca6.jpg";